import { createAction, props } from '@ngrx/store';
export const setFundChartFormat = createAction('[Fund Chart] Set format', props());
